export const LOAD_BASIC_MASTERS = 'loadBasicMasters'
